// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__eS5EF","modal__close":"styles_modal__close__7l2cV","modal__buttons":"styles_modal__buttons__OjKBF"};